import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'shared/components/ui/tooltip';
import colorsStore from 'shared/store/colorsStore';
import { MenuItem } from './MenuItemButton.types';

type MenuItemProps = {
  item: MenuItem;
  isTabletView?: boolean;
  children: React.ReactNode;
};

const MenuItemButtonWrapper: React.FC<MenuItemProps> = ({ item, isTabletView = false, children }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const { t } = useTranslation();

  // Don't show tooltips in tablet view as we already show text labels
  if (isTabletView) {
    return children;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={0}
          align="start"
          backgroundColor={colorsConfig.tooltipBackground}
          textColor={colorsConfig.tooltipText}
        >
          <p>{t(`menu.${item.name}`)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MenuItemButtonWrapper;
